export const CREATE_MODULE_SUCCESS_MESSAGE = 'Módulo criado com sucesso';
export const CREATE_MODULE_ERROR_MESSAGE = 'Erro ao criar Módulo. Tente novamente';
export const DIRECTORIES_EMPTY_TITLE = 'Ops! Parece que não há módulos criados no momento';
export const DIRECTORIES_EMPTY_SUBTITLE = 'Crie novos módulos para organizar os arquivos do GD';
export const DIRECTORIES_ACTIONS_PLACEHOLDER_MESSAGE =
  'Selecione um módulo, pasta ou arquivo para ser configurado';
export const LOAD_MODULES_ERROR_MESSAGE = 'Erro ao carregar módulos. Tente novamente';
export const CREATE_FOLDER_SUCCESS_MESSAGE = 'Pasta criada com sucesso';
export const CREATE_FOLDER_ERROR_MESSAGE = 'Erro ao criar Pasta. Tente novamente';
export const MOVE_ITEM_SUCCESS_MESSAGE = 'Item movido com sucesso';
export const MOVE_ITEMS_SUCCESS_MESSAGE = 'Itens movidos com sucesso';
export const MOVE_ITEM_ERROR_MESSAGE = 'Erro ao mover item. Tente novamente';
export const ADD_RECORD_SUCCESS_MESSAGE = 'Registro adicionado com sucesso';
export const ADD_RECORD_ERROR_MESSAGE = 'Erro ao adicionar Registro. Tente novamente';
export const MATRIX_ALREADY_LINKED_MESSAGE = 'Registro já vinculado a um módulo';
export const MATRIX_PREFIX_PINNED_TO_OTHER_MODULE_MESSAGE =
  'Não é possível adicionar. Todas as revisões de uma matriz devem estar no mesmo módulo';
export const MATRICES_NOT_ELIGIBLE_FOR_LINK_MESSAGE =
  'Registro não está mais disponível para adição';
export const ADD_DOCUMENT_SUCCESS_MESSAGE = 'Documento adicionado com sucesso';
export const ADD_DOCUMENT_ERROR_MESSAGE = 'Erro ao adicionar Documento. Tente novamente';
export const ADD_DOCUMENT_DUPLICATE_MESSAGE = 'Documento já existe na pasta selecionada';
export const DELETE_SELECTION_CONFIRMATION_DESCRIPTION = 'A ação não pode ser desfeita.';
export const DELETE_QUALITY_RECORDS_ROOT_LOCKED_MESSAGE =
  'A pasta Registros da Qualidade não pode ser excluída.';
export const DELETE_MATRIX_FOLDER_LOCKED_MESSAGE =
  'A exclusão de pastas de matriz aguarda definição de comportamento.';
export const REMOVE_MATRIX_LINK_LOCKED_MESSAGE =
  'A remoção de vínculos de matriz aguarda definição de comportamento.';
export const DELETE_MODULE_WITH_MATRICES_LOCKED_MESSAGE =
  'A exclusão de módulos com matrizes aguarda definição de comportamento.';

export type DeleteMessageItemType =
  'module' | 'folder' | 'document' | 'record' | 'matrix' | 'items';

interface DeleteMessageContent {
  confirmationTitle: string;
  successMessage: string;
  errorMessage: string;
}

const DELETE_MESSAGE_CONTENT_BY_ITEM_TYPE: Record<DeleteMessageItemType, DeleteMessageContent> = {
  module: {
    confirmationTitle: 'Tem certeza que deseja deletar o Módulo?',
    successMessage: 'Módulo deletado com sucesso',
    errorMessage: 'Erro ao deletar Módulo. Tente novamente',
  },
  folder: {
    confirmationTitle: 'Tem certeza que deseja deletar a Pasta?',
    successMessage: 'Pasta deletada com sucesso',
    errorMessage: 'Erro ao deletar Pasta. Tente novamente',
  },
  document: {
    confirmationTitle: 'Tem certeza que deseja deletar o Documento?',
    successMessage: 'Documento deletado com sucesso',
    errorMessage: 'Erro ao deletar Documento. Tente novamente',
  },
  record: {
    confirmationTitle: 'Tem certeza que deseja deletar o Registro?',
    successMessage: 'Registro deletado com sucesso',
    errorMessage: 'Erro ao deletar Registro. Tente novamente',
  },
  matrix: {
    confirmationTitle: 'Tem certeza que deseja deletar a Matriz?',
    successMessage: 'Matriz deletada com sucesso',
    errorMessage: 'Erro ao deletar Matriz. Tente novamente',
  },
  items: {
    confirmationTitle: 'Tem certeza que deseja deletar os itens selecionados?',
    successMessage: 'Itens deletados com sucesso',
    errorMessage: 'Erro ao deletar itens. Tente novamente',
  },
};

export function buildDeleteConfirmationTitle(itemType: DeleteMessageItemType): string {
  return DELETE_MESSAGE_CONTENT_BY_ITEM_TYPE[itemType].confirmationTitle;
}

export function buildDeleteSuccessMessage(itemType: DeleteMessageItemType): string {
  return DELETE_MESSAGE_CONTENT_BY_ITEM_TYPE[itemType].successMessage;
}

export function buildDeleteErrorMessage(itemType: DeleteMessageItemType): string {
  return DELETE_MESSAGE_CONTENT_BY_ITEM_TYPE[itemType].errorMessage;
}

export const SAVE_CONFIGURE_SUCCESS_MESSAGE = 'Edição salva com sucesso';
export const SAVE_CONFIGURE_ERROR_MESSAGE = 'Erro ao salvar. Tente novamente';

export const SAVE_PERMISSIONS_SUCCESS_MESSAGE = 'Permissões salvas com sucesso';
export const COPY_PERMISSIONS_SUCCESS_MESSAGE = 'Permissões copiadas';
export const PASTE_PERMISSIONS_CONFIRMATION_TITLE = 'Tem certeza que deseja colar as permissões?';
export const PASTE_PERMISSIONS_CONFIRMATION_DESCRIPTION =
  'Isso sobrescreverá todas as permissões existentes';
export const PASTE_PERMISSIONS_CONFIRM_BUTTON_TEXT = 'Confirmar';
export const PASTE_PERMISSIONS_CANCEL_BUTTON_TEXT = 'Cancelar';
export const SAVE_PERMISSIONS_ERROR_MESSAGE = 'Erro ao salvar permissões. Tente novamente';
export const LOAD_PERMISSIONS_ERROR_MESSAGE = 'Erro ao carregar permissões. Tente novamente';
export const PERMISSIONS_EMPTY_RESULTS_MESSAGE = 'Nenhum resultado encontrado';
export const PERMISSIONS_LOADING_MESSAGE = 'Carregando permissões...';
export const PERMISSIONS_UNAVAILABLE_MESSAGE =
  'Permissões indisponíveis para este item. Recarregue a tela e tente novamente';
